module.exports = __webpack_public_path__ + "static/media/btn_actions_1075_725.42c2d5a3.png";